<template>
  <v-dialog v-model="open" persistent max-width="520">
    <v-card>
      <v-layout  class="p-5" wrap>
        <div class="display-flex w-100 justify-content-center">
          <h4>{{headerMessage}}</h4>
        </div>
        <div class="display-flex w-100 justify-content-center">
          <span v-html="description"></span>
        </div>
      </v-layout>
      <div class="display-flex w-100 justify-content-end">
        <v-btn color="grey darken-1" flat @click="$emit('close')">Zamknij</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
    export default {
        name: 'InfoModal',
      props: {
        open: Boolean,
        description: String,
        headerMessage: String,
      },
    };
</script>

<style scoped>

</style>
